export const INELIGIBLE_REASON = {
    clearOutstandingAmountDue: 'clear outstanding amount',
    notEligibleDueToDelinquency: 'autopay not eligible due to delinquency days',
    notEnabledForChannelOrProduct: 'not enabled for this channel or product',
    oneTimePaymentExists: 'one time payment exists',
    statementNotGenerated: 'statement not generated',
    within48HourWindow: 'In 48 hours window'
};
